"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SourceItems = require("../../constants/SourceItems");
var _sourceFileHelper = require("../../utils/sourceFileHelper");
var _TemplateChooser = _interopRequireDefault(require("./TemplateChooser"));
var _TemplateTabs = _interopRequireDefault(require("./TemplateTabs"));
var _Tabs = require("../../constants/Tabs");
var TemplatesWrapper = function TemplatesWrapper(_ref) {
  var title = _ref.title,
    onCancel = _ref.onCancel,
    onSelectTemplate = _ref.onSelectTemplate,
    mediaSources = _ref.mediaSources,
    templateTabs = _ref.templateTabs,
    broadcastEventMedia = _ref.broadcastEventMedia,
    broadcastTemplates = _ref.broadcastTemplates,
    onTabChanged = _ref.onTabChanged;
  var templates = templateTabs.currentTab === _Tabs.EVENT ? broadcastEventMedia.eventMedia : broadcastTemplates.templates;
  var isLoading = templateTabs.currentTab === _Tabs.EVENT ? broadcastEventMedia.isLoading : broadcastTemplates.isLoading;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TemplateTabs["default"], {
    onTabChanged: onTabChanged,
    currentTab: templateTabs.currentTab
  }), /*#__PURE__*/_react["default"].createElement(_TemplateChooser["default"], {
    mediaSources: mediaSources,
    isLoading: isLoading,
    templates: title !== _Tabs.MEDIA ? (0, _sourceFileHelper.filterByValidFileExtension)(templates, _SourceItems.IMAGE_FILE) : (0, _sourceFileHelper.filterByValidFileExtension)(templates),
    onCancel: onCancel,
    onSelectTemplate: onSelectTemplate,
    isEventTemplate: templateTabs.currentTab === _Tabs.EVENT
  }));
};
TemplatesWrapper.propTypes = {
  title: _propTypes["default"].string.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  onSelectTemplate: _propTypes["default"].func.isRequired,
  mediaSources: _propTypes["default"].array,
  templateTabs: _propTypes["default"].shape({
    currentTab: _propTypes["default"].string
  }),
  broadcastEventMedia: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    eventMedia: _propTypes["default"].any
  }),
  broadcastTemplates: _propTypes["default"].shape({
    templates: _propTypes["default"].any,
    isLoading: _propTypes["default"].bool
  }),
  onTabChanged: _propTypes["default"].func
};
var _default = exports["default"] = TemplatesWrapper;